import { useMutation, useQueryClient } from "@tanstack/react-query";

import { api } from "@utils/api";
import { showSuccessNotification } from "@utils/showNotification";

import { radiologyQKeys } from "@hooks/queries/radiology/queryKeys";
import { useQueryErrorHandling } from "@hooks/useQueryErrorHandling";


interface MutationProps {
  radiology: FormData;
  radId: string;
  patientId: string;
}

export const useUpdateRadiology = () => {
  const queryClient = useQueryClient();
  const handleErrors = useQueryErrorHandling();

  return useMutation({
    mutationFn: ({ radiology, radId }: MutationProps) => {
      return api.patch(`radiology/${radId}`, radiology, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
    },
    onSuccess: (_, variables) => {
      showSuccessNotification({
        title: "success",
        message: "update-radiology-success",
      });
      queryClient.invalidateQueries({
        queryKey: radiologyQKeys.patient(variables.patientId),
      });
    },

    onError: (res: any) => {
      console.error("[From Update Radiology]", res);

      handleErrors(res, "mutation");
    },
  });
};
